import * as React from "react";
import Typography from "@mui/material/Typography";
import Props from "./index.d";

const TitleComponent: React.FC<Props> = (props) => {
  return <Typography variant="h2">{props.title}</Typography>;
};

export default TitleComponent;
